import { useEffect } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

type Props = {
  open: boolean;
  title?: string;
  onClose: () => void;
  children: React.ReactNode;
  widthClass?: string;
};

export default function Modal({ open, title, onClose, children, widthClass="max-w-xl" }: Props) {
  useEffect(() => {
    if (!open) return;
    const onEsc = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onEsc);
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", onEsc); document.body.style.overflow = ""; };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute inset-0 flex items-start justify-center p-2 sm:p-4 lg:p-6 lg:items-center">
        <div
          className={`max-h-[calc(100dvh-16px)] w-full overflow-y-auto rounded-2xl border border-slate-100 bg-white shadow-[0_12px_40px_rgba(0,0,0,.18)] sm:max-h-[calc(100dvh-32px)] sm:rounded-3xl lg:max-h-[calc(100dvh-48px)] ${widthClass}`}
        >
          <div className="flex items-center justify-between px-4 pt-4 sm:px-6 sm:pt-5 lg:px-8">
            {title ? <h3 className="text-2xl font-semibold">{title}</h3> : <div />}
            <button onClick={onClose} aria-label="Закрыть" className="rounded-full p-2 hover:bg-slate-100">
              <X size={22} />
            </button>
          </div>
          <div className="px-4 pb-4 pt-2 sm:px-6 sm:pb-6 lg:px-8 lg:pb-8">{children}</div>
        </div>
      </div>
    </div>,
    document.body,
  );
}
